import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import {getRequest, postRequest, postFormDataRequest, putRequest, putFormDataRequest, deleteRequest} from "@/api/api";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import i18n from '@/lang';
import { languages, setLocale } from '@/lang';

import LeaveMessage from "@/components/common/LeaveMessage.vue";
import LanguageSwitcher from "@/components/common/LanguageSwitcher.vue";

Vue.component("LeaveMessage",LeaveMessage);
Vue.component("LanguageSwitcher", LanguageSwitcher);

Vue.use(ElementUI);

Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.postFormDataRequest = postFormDataRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.putFormDataRequest = putFormDataRequest;
Vue.prototype.deleteRequest = deleteRequest;

// 暴露语言列表与切换方法给所有组件
Vue.prototype.$languages = languages;
Vue.prototype.$setLocale = setLocale;


Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
